import AppBar from 'material-ui/AppBar'
import Grid from 'material-ui/Grid'
import { StyleRulesCallback, withStyles } from 'material-ui/styles'
import Toolbar from 'material-ui/Toolbar'
import * as React from 'react'
import { SFC } from 'react'
import { RouteComponentProps } from 'react-router'
import { ClientQuote } from '../components/ClientQuote'
import { Footer } from '../components/Footer'
import { ProjectSelectorCard, ProjectSelectorTitle } from '../components/ProjectSelectorCard'
import { SpreadBody } from '../components/SpreadBody'
import { AiSpread } from './AiSpread'
import { DotNetSpread } from './DotNetSpread'
import { OfficePhotos } from './OfficePhotos'
import { ServicesSpread } from './ServicesSpread'
import { TeamSpread } from './TeamSpread'
import { WithStyles } from 'material-ui'

export class MainIndex extends React.Component<RouteComponentProps<{}, {}>, {}> {

    topNavStyles: StyleRulesCallback = theme => ({
        root: {
            padding: theme.spacing.unit,
            [theme.breakpoints.up('sm')]: {
                width: '100%',
                textAlign: 'left'
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                textAlign: 'center'
            },
        },
    })

    TopNavigation: SFC<WithStyles> = ({classes}) => {
        return (
            <AppBar
                position='static'
                color='default'
                elevation={0}
                style={{background: 'transparent'}}
            >
                <Toolbar>
                    <div className={classes.root}>
                        <img
                            src='/img/Logo.svg'
                            alt='logo'
                            style={{
                                padding: '20px 20px 0',
                                display: 'inline-block',
                                height: 58
                            }}
                        />
                    </div>
                </Toolbar>
            </AppBar>
        )
    }

    ProjectSelectorSpread = () => {
        return (
            <div style={{maxWidth: 900, margin: 'auto', padding: 0}}>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <ProjectSelectorCard
                            img='/img/avant-link-photo-blue.png'
                            color='#36426a'
                            height={555}
                            onClick={() => this.props.router.push('/avant')}
                        >
                            <ProjectSelectorTitle title='Avant Assessment' sub='Leader in Language Assessment'/>
                        </ProjectSelectorCard>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ProjectSelectorCard
                            img='/img/xprize-link-photo-gold.png'
                            color='#36426a'
                            height={270}
                            marginBottom={15}
                            onClick={() => this.props.router.push('/xprize')}
                        >
                            <ProjectSelectorTitle title=' Adult Literacy XPRIZE' sub='$7m Adult Literacy'/>
                        </ProjectSelectorCard>
                        <ProjectSelectorCard
                            img='/img/partner-link-photo-green.png'
                            color='#36426a'
                            height={270}
                            onClick={() => this.props.router.push('/random-lengths')}
                        >
                            <ProjectSelectorTitle title='Random Lengths' sub='Pioneer of Wood Products Info'/>
                        </ProjectSelectorCard>
                    </Grid>
                </Grid>
            </div>
        )
    }

    BongQuote = () => {
        return (
            <SpreadBody greyBg>
                <ClientQuote
                    clientName='David Bong'
                    clientTitle='CEO, Avant Assessment'
                    clientImg='/img/headshots/bong.png'
                    quote={'"Twenty Ideas brings a special combination of efficient ' +
                    'management with serious technology chops"'}
                />
            </SpreadBody>
        )
    }

    render() {
        const {TopNavigation, ProjectSelectorSpread, BongQuote} = this
        const Nav: React.ComponentType = withStyles(this.topNavStyles)(TopNavigation)

        return (
            <div style={{textAlign: 'center'}}>
                <Nav/>
                <DotNetSpread/>
                <ProjectSelectorSpread/>
                <ServicesSpread/>
                <AiSpread/>
                <TeamSpread/>
                <BongQuote/>
                <OfficePhotos/>
                <Footer navigateTo={this.props.router.push}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/index/MainIndex.tsx